import { Pipe, PipeTransform } from '@angular/core';
import { Driver } from '../models/domain/Driver';



@Pipe({ name: 'fullName' })
export class DriverFullNamePipe implements PipeTransform {


    public transform(driver?: Driver): string {
        let fullName = '';
        if (driver) {
            if (driver.FN) {
                fullName += (fullName ? ' ' : '') + driver.FN;
            }
            if (driver.LN) {
                fullName += (fullName ? ' ' : '') + driver.LN;
            }
        }
        return fullName;
    }
}
